import React from "react";
import { Link } from "react-router-dom";
import {
  HiArrowLeft,
  HiInformationCircle,
  HiPhone,
  HiMail,
  HiGlobeAlt,
  HiChevronRight,
} from "react-icons/hi";

const SUPPORT_INFO = {
  callCenter: "2033",
  contactNumber: "252619006649",
  email: "info@caaficare.so",
  website: "https://caaficare.so",
};

const ContactRow = ({ icon: Icon, title, value, href, target, rel }) => (
  <a
    href={href}
    target={target}
    rel={rel}
    className="flex items-center py-4 px-4 hover:bg-gray-50 transition-colors"
  >
    <div className="w-10 h-10 rounded-full bg-blue-500/10 flex items-center justify-center text-[#6CA9F5] mr-4 flex-shrink-0">
      <Icon className="w-5 h-5" />
    </div>
    <div className="flex-1 min-w-0">
      <p className="text-sm font-medium text-gray-500">{title}</p>
      <p className="text-base font-semibold text-gray-900 mt-0.5">{value}</p>
    </div>
    <HiChevronRight className="w-5 h-5 text-gray-400 flex-shrink-0" />
  </a>
);

const Help = () => {
  return (
    <div className="min-h-screen bg-gray-100 pt-20">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 sticky top-0 z-10">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 flex items-center justify-between h-14">
          <Link
            to="/"
            className="p-2 -ml-2 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors"
            aria-label="Back"
          >
            <HiArrowLeft className="w-6 h-6" />
          </Link>
          <h1 className="text-lg font-bold text-gray-900">Help & Support</h1>
          <div className="w-10" />
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-6">
        {/* Info Section */}
        <div className="flex gap-3 p-4 rounded-xl bg-blue-500/10 border border-blue-500/20 mb-6">
          <HiInformationCircle className="w-8 h-8 text-[#6CA9F5] flex-shrink-0 mt-0.5" />
          <p className="text-sm text-gray-800 leading-relaxed">
            Need assistance? Our support team is here to help you with any
            questions, appointments, or technical issues.
          </p>
        </div>

        {/* Quick Contact */}
        <h2 className="text-base font-semibold text-gray-500 mt-6 mb-2">
          Quick Contact
        </h2>
        <div className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-100">
          <ContactRow
            icon={HiPhone}
            title="Call Center"
            value={SUPPORT_INFO.callCenter}
            href={`tel:${SUPPORT_INFO.callCenter}`}
          />
          <div className="h-px bg-gray-100 ml-[4.5rem]" />
          <ContactRow
            icon={HiPhone}
            title="WhatsApp Number"
            value={`+252 61 9006649`}
            href={`https://wa.me/${SUPPORT_INFO.contactNumber}`}
          />
        </div>

        {/* Digital Support */}
        <h2 className="text-base font-semibold text-gray-500 mt-6 mb-2">
          Digital Support
        </h2>
        <div className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-100">
          <ContactRow
            icon={HiMail}
            title="Professional Email"
            value={SUPPORT_INFO.email}
            href={`mailto:${SUPPORT_INFO.email}`}
          />
          <div className="h-px bg-gray-100 ml-[4.5rem]" />
          <ContactRow
            icon={HiGlobeAlt}
            title="Official Website"
            value={SUPPORT_INFO.website}
            href={SUPPORT_INFO.website}
            target="_blank"
            rel="noopener noreferrer"
          />
        </div>

        <p className="text-center text-sm text-gray-500 mt-12">
          CaafiCare Website v1.0.0
        </p>
      </div>
    </div>
  );
};

export default Help;
